// extracted by mini-css-extract-plugin
export default {"company":"Event_company__or5xW","event":"Event_event__PrDeH","dateBlock":"Event_dateBlock__-FbBO","eventName":"Event_eventName__xNauY","date":"Event_date__HHBY7"};